import {sortWith} from '../../sortWith'
import {comparator} from './comparator'

export const nameComparator = <T extends {name: string}>(a: T, b: T): number => comparator(a, b, 'name')

export const sortWithName = sortWith(nameComparator)
